import { useMemo } from "react";
import { applyDisplayFilter, applyDisplayFilterFields, applyDisplayFilterLayerFields, setupFieldClassFromConfig } from "../actions/Tenants/config/applyDisplayFilter";
import useConfig from "../actions/Tenants/config/configHook";
import useAuthorization from "../utils/authorization";


export const useFields = () => {
    const config = useConfig();
    const { facility } = useAuthorization();
    const fruitTypes = config.get_fruit_types();
    const stages = config.stages || [];
    // * EFQ-3850 — single source of truth lives on `config.root_config`.
    // * Memoize so wrapper closures keep referential equality between renders.
    const rootDateTimeFormats = useMemo(() => ({
        date_format: config?.root_config?.date_format,
        datetime_format: config?.root_config?.datetime_format,
    }), [config?.root_config?.date_format, config?.root_config?.datetime_format]);

    return {
        applyDisplayFilter: (fields, filter: any = {}) => applyDisplayFilter(fields, { facilities: facility ? [facility] : undefined, ...filter }),
        applyDisplayFilterFields: (fields, filter: any = {}) => applyDisplayFilterFields(fields, { facilities: facility ? [facility] : undefined, ...filter }),
        applyDisplayFilterLayerFields: (fields, filter: any = {}) => applyDisplayFilterLayerFields(fields, { facilities: facility ? [facility] : undefined, ...filter }, { fruitTypes, stages, rootDateTimeFormats }),
        setupFieldClassFromConfig: (fieldConfig, filter: any = {}) => setupFieldClassFromConfig(fieldConfig, { facilities: facility ? [facility] : undefined, ...filter }, { fruitTypes, stages, rootDateTimeFormats }),

    };
};
